import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import {
  AdministrationCarrierUserService,
  CarrierUserModel,
  CarrierUserRequest,
  CarrierUserEditRequest,
  CarrierUserListRequest
} from '../autogenerated';
import { REQUEST_OPTIONS } from '../constants';
import { RequestOptionsJsonType, RequestOptionsVoidType } from '../types';

@Injectable({ providedIn: 'root' })
export class AdministrationCarrierUserApiService {
  constructor(private apiService: AdministrationCarrierUserService) {}

  public activateCarrierUser(carrierId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.adminCarrierUserActivate(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public addCarrierUser(carrierId: string, body: CarrierUserRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.adminCarrierUserAdd(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public deleteCarrierUser(carrierId: string, userId: string, requestOptions: RequestOptionsVoidType = REQUEST_OPTIONS): Observable<void> {
    return this.apiService.adminCarrierUserDelete(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public editCarrierUser(carrierId: string, userId: string, body: CarrierUserEditRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.adminCarrierUserEdit(carrierId, userId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public getCarrierUser(carrierId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.adminCarrierUserGet(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public listCarrierUsers(carrierId: string, body: CarrierUserListRequest, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel[]> {
    return this.apiService.adminCarrierUserList(carrierId, body, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public resendCarrierUserInvitation(carrierId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.adminCarrierUserResendInvitation(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
  public suspendCarrierUser(carrierId: string, userId: string, requestOptions: RequestOptionsJsonType = REQUEST_OPTIONS): Observable<CarrierUserModel> {
    return this.apiService.adminCarrierUserSuspend(carrierId, userId, requestOptions.observe, requestOptions.reportProgress, requestOptions.options);
  };
}
